module.exports = __webpack_public_path__ + "img/delete-cart.7b3dbf50.svg";